import { render } from "./LogoElem.vue?vue&type=template&id=94b02822&ts=true"
import script from "./LogoElem.vue?vue&type=script&lang=ts"
export * from "./LogoElem.vue?vue&type=script&lang=ts"

import "./LogoElem.vue?vue&type=style&index=0&id=94b02822&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__